import React from 'react';
import { Button } from '@/components/ui/button';
import { 
  DropdownMenu, 
  DropdownMenuContent, 
  DropdownMenuItem, 
  DropdownMenuTrigger 
} from '@/components/ui/dropdown-menu';
import { Calendar, Download, ExternalLink } from 'lucide-react';
import { buildCalendarArtifacts, downloadICS } from '@/utils/calendarLinks';

interface CalendarDropdownProps {
  title: string;
  description: string;
  startDate: Date;
  endDate: Date;
  location?: string;
  className?: string;
}

export const CalendarDropdown: React.FC<CalendarDropdownProps> = ({
  title,
  description,
  startDate,
  endDate,
  location,
  className
}) => {
  const handleDownloadICS = () => {
    const { icsContent } = buildCalendarArtifacts({
      title,
      description,
      start: startDate,
      end: endDate,
      location: location || ''
    });
    const fileName = `${title.replace(/\s+/g, '-').toLowerCase()}.ics`;
    downloadICS(fileName, icsContent);
  };

  const handleOpenGoogleCalendar = () => {
    const { googleUrl } = buildCalendarArtifacts({
      title,
      description,
      start: startDate,
      end: endDate,
      location: location || ''
    });
    window.open(googleUrl, '_blank');
  };

  const handleOpenOutlook = () => {
    const { outlookUrl } = buildCalendarArtifacts({
      title,
      description,
      start: startDate,
      end: endDate,
      location: location || ''
    });
    window.open(outlookUrl, '_blank');
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className={className}>
          <Calendar className="h-3 w-3 mr-1" />
          Add to Calendar
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={handleDownloadICS}>
          <Download className="h-3 w-3 mr-2" />
          Download .ics file
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handleOpenGoogleCalendar}>
          <ExternalLink className="h-3 w-3 mr-2" />
          Google Calendar
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handleOpenOutlook}>
          <ExternalLink className="h-3 w-3 mr-2" />
          Outlook Calendar
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};